import type { AppEdition } from "@mk/shared";
import { isTurkishIos } from "./native.ts";

/** "app-store": iOS uygulaması. Apple dış ödeme/bağış bağlantısına izin vermiyor (3.1.1). */
export type AppDistribution = "web" | "play" | "app-store";

const STORAGE_KEY = "mk-distribution";

export function resolveDistribution(search: string, stored: string | null): AppDistribution {
  const source = new URLSearchParams(search).get("source");
  return source === "play" || stored === "play" ? "play" : "web";
}

/** TWA başlangıç işaretini sonraki açılışlar için kalıcılaştırır. */
export function captureAppDistribution(): AppDistribution {
  let stored: string | null = null;
  try {
    stored = window.localStorage.getItem(STORAGE_KEY);
  } catch {
    /* Gizli sekmede/depolama engelliyken URL işareti yine yeterli. */
  }

  const distribution = resolveDistribution(window.location.search, stored);
  if (distribution === "play") {
    try {
      window.localStorage.setItem(STORAGE_KEY, "play");
    } catch {
      /* Depolama engelliyse yalnız o açılıştaki URL işareti kullanılır. */
    }
  }
  return distribution;
}

export function currentAppDistribution(): AppDistribution {
  if (isTurkishIos()) return "app-store";
  let stored: string | null = null;
  try {
    stored = window.localStorage.getItem(STORAGE_KEY);
  } catch {
    /* Depolama yoksa normal web kabul edilir. */
  }
  return resolveDistribution(window.location.search, stored);
}

export function canShowSupport(
  supportUrl: string | null,
  supportInPlay: boolean,
  distribution: AppDistribution,
): boolean {
  if (distribution === "app-store") return false;
  return Boolean(supportUrl) && (distribution !== "play" || supportInPlay);
}

export function localizedSupportUrl(rawUrl: string, edition: AppEdition): string {
  const url = new URL(rawUrl);
  if (
    url.protocol !== "https:" ||
    !["kreosus.com", "www.kreosus.com"].includes(url.hostname)
  ) {
    throw new Error("Invalid support URL");
  }
  url.searchParams.set("hl", edition);
  return url.toString();
}

export function resolveSupportHref(
  rawUrl: string | null,
  supportInPlay: boolean,
  distribution: AppDistribution,
  edition: AppEdition,
): string | null {
  if (!canShowSupport(rawUrl, supportInPlay, distribution) || !rawUrl) return null;
  try {
    return localizedSupportUrl(rawUrl, edition);
  } catch {
    return null;
  }
}
